// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function preventDefault(submit, event) {
  if (!event.defaultPrevented) {
    event.preventDefault();
  }
  return submit();
}

function toValueOnChange(event) {
  return event.target.value;
}

function toValueOnBlur(event) {
  return event.target.value;
}

function toCheckedOnChange(event) {
  return event.target.checked;
}

function toCheckedOnBlur(event) {
  return event.target.checked;
}

let Dom = {
  preventDefault: preventDefault,
  toValueOnChange: toValueOnChange,
  toValueOnBlur: toValueOnBlur,
  toCheckedOnChange: toCheckedOnChange,
  toCheckedOnBlur: toCheckedOnBlur
};

exports.Dom = Dom;
/* No side effect */
